import { useMemo } from 'react'
import Markdown from 'react-markdown'
import styled from '@emotion/styled'

const StyledMarkdown = styled(Markdown)(({theme}) => ({
	p: {
		margin: theme.spacing(0, 0, 1),
	},
	ul: {
		margin: theme.spacing(0, 0, 1),
	},
	'*:last-child': {
		margin: 0,
	},
}))

interface L1MarkdownBlockProps {
	content?: string
}

const L1Markdown = ({content}: L1MarkdownBlockProps) => {
	const translated = useMemo(() => {
		// NOTE this is special support for the content coming out of
		// Dambro's directory, is not part of standard markdown spec
		return content?.replaceAll("¶", "\n")
	}, [content])
	return <StyledMarkdown>{translated}</StyledMarkdown>
}

export default L1Markdown
